module.exports = __webpack_public_path__ + "img/huoke_icon12.08e6cb2a.png";